import React from "react";
import styled from "styled-components";
import Navbar from "../global/navbar";

const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  gap: 20px;
`;

const Title = styled.h1`
  color: #ffffff;
  margin: 0;
`;

const HomePage = () => {
  return (
    <>
    <Section>
      <Title>Welcome to Pingcraft Docs</Title>
      <p style={{ color: "#aaaaaa", textAlign: "center", maxWidth: "600px" }}>
        This is your landing page. Use the navigation above to browse the docs.
      </p>
      {/* Add more content as needed */}
    </Section>
    </>
  );
};

export default HomePage;